module.exports = __webpack_public_path__ + "img/wifi-reverb-logo.cace5b40.png";